import React, { useState } from "react";
import "./styles/adult.css";

export function validateVbsForm(data) {
  if (!String(data.childFirstName || "").trim()) return "Child first name is required.";
  if (!String(data.childLastName || "").trim()) return "Child last name is required.";
  if (!String(data.childDob || "").trim()) return "Child DOB is required.";
  if (!String(data.parentFirstName || "").trim()) return "Parent/guardian first name is required.";
  if (!String(data.parentLastName || "").trim()) return "Parent/guardian last name is required.";
  if (!String(data.parentEmail || "").trim()) return "Parent/guardian email is required.";
  if (!String(data.parentPhone || "").trim()) return "Parent/guardian phone number is required.";
  if (data.hasAllergies === "yes" && !String(data.allergyDetails || "").trim()) {
    return "Please describe the allergies.";
  }
  if (data.parentBringingChild === "no") {
    if (!String(data.alternateFirstName || "").trim()) {
      return "Please enter the first name for drop off/pick up.";
    }
    if (!String(data.alternateLastName || "").trim()) {
      return "Please enter the last name for drop off/pick up.";
    }
    if (!String(data.alternatePhone || "").trim()) {
      return "Please enter the phone number for drop off/pick up.";
    }
  }
  return null;
}

export default function VbsForm({ onComplete }) {
  const [childFirstName, setChildFirstName] = useState("");
  const [childLastName, setChildLastName] = useState("");
  const [childDob, setChildDob] = useState("");
  const [hasAllergies, setHasAllergies] = useState("no");
  const [allergyDetails, setAllergyDetails] = useState("");

  const [parentFirstName, setParentFirstName] = useState("");
  const [parentLastName, setParentLastName] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [parentPhone, setParentPhone] = useState("");

  const [parentBringingChild, setParentBringingChild] = useState("yes");
  const [alternateFirstName, setAlternateFirstName] = useState("");
  const [alternateLastName, setAlternateLastName] = useState("");
  const [alternatePhone, setAlternatePhone] = useState("");

  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    const validationError = validateVbsForm({
      childFirstName,
      childLastName,
      childDob,
      hasAllergies,
      allergyDetails,
      parentFirstName,
      parentLastName,
      parentEmail,
      parentPhone,
      parentBringingChild,
      alternateFirstName,
      alternateLastName,
      alternatePhone
    });
    if (validationError) {
      setError(validationError);
      return;
    }

    onComplete({
      formType: "vbs",
      childFirstName: childFirstName.trim(),
      childLastName: childLastName.trim(),
      childDob: childDob.trim(),
      hasAllergies,
      allergyDetails: hasAllergies === "yes" ? allergyDetails.trim() : "",
      parentFirstName: parentFirstName.trim(),
      parentLastName: parentLastName.trim(),
      parentEmail: parentEmail.trim(),
      parentPhone: parentPhone.trim(),
      parentBringingChild,
      alternateFirstName: parentBringingChild === "no" ? alternateFirstName.trim() : "",
      alternateLastName: parentBringingChild === "no" ? alternateLastName.trim() : "",
      alternatePhone: parentBringingChild === "no" ? alternatePhone.trim() : ""
    });
  };

  return (
    <form className="adult-form" onSubmit={handleSubmit} noValidate>
      <h2>VBS Registration</h2>
      <p className="muted small">Please fill out all required fields.</p>

      <div className="two-col">
        <div className="field">
          <label>
            Child first name <span className="required">*</span>
          </label>
          <input value={childFirstName} onChange={(e) => setChildFirstName(e.target.value)} required />
        </div>
        <div className="field">
          <label>
            Child last name <span className="required">*</span>
          </label>
          <input value={childLastName} onChange={(e) => setChildLastName(e.target.value)} required />
        </div>
      </div>

      <div className="field">
        <label>
          Child DOB <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="MM/DD/YYYY"
          value={childDob}
          onChange={(e) => setChildDob(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label>
          Any allergies? <span className="required">*</span>
        </label>
        <select value={hasAllergies} onChange={(e) => setHasAllergies(e.target.value)}>
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      </div>

      {hasAllergies === "yes" ? (
        <div className="field">
          <label>
            What are they? <span className="required">*</span>
          </label>
          <input value={allergyDetails} onChange={(e) => setAllergyDetails(e.target.value)} required />
          <p className="muted" style={{ marginTop: 8 }}>
            Please note: we cannot guarantee there will not be cross contamination of food allergens.
          </p>
        </div>
      ) : null}

      <div className="two-col">
        <div className="field">
          <label>
            Parent/guardian first name <span className="required">*</span>
          </label>
          <input value={parentFirstName} onChange={(e) => setParentFirstName(e.target.value)} required />
        </div>
        <div className="field">
          <label>
            Parent/guardian last name <span className="required">*</span>
          </label>
          <input value={parentLastName} onChange={(e) => setParentLastName(e.target.value)} required />
        </div>
      </div>

      <div className="two-col">
        <div className="field">
          <label>
            Parent/guardian email <span className="required">*</span>
          </label>
          <input type="email" value={parentEmail} onChange={(e) => setParentEmail(e.target.value)} required />
        </div>
        <div className="field">
          <label>
            Parent/guardian phone number <span className="required">*</span>
          </label>
          <input value={parentPhone} onChange={(e) => setParentPhone(e.target.value)} required />
        </div>
      </div>

      <div className="field">
        <label className="field-label">
          Will the parent/guardian be bringing the child to VBS? <span className="required">*</span>
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
          <input
            type="radio"
            name="parentBringingChild"
            checked={parentBringingChild === "yes"}
            onChange={() => {
              setParentBringingChild("yes");
              setAlternateFirstName("");
              setAlternateLastName("");
              setAlternatePhone("");
            }}
          />
          Yes
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
          <input
            type="radio"
            name="parentBringingChild"
            checked={parentBringingChild === "no"}
            onChange={() => setParentBringingChild("no")}
          />
          No
        </label>
      </div>

      {parentBringingChild === "no" ? (
        <div className="two-col">
          <div className="field">
            <label>
              First name of person responsible for drop off/pick up <span className="required">*</span>
            </label>
            <input value={alternateFirstName} onChange={(e) => setAlternateFirstName(e.target.value)} required />
          </div>
          <div className="field">
            <label>
              Last name of person responsible for drop off/pick up <span className="required">*</span>
            </label>
            <input value={alternateLastName} onChange={(e) => setAlternateLastName(e.target.value)} required />
          </div>
          <div className="field">
            <label>
              Phone number of person responsible for drop off/pick up <span className="required">*</span>
            </label>
            <input value={alternatePhone} onChange={(e) => setAlternatePhone(e.target.value)} required />
          </div>
        </div>
      ) : null}

      {error ? (
        <div className="note" style={{ color: "crimson" }}>
          {error}
        </div>
      ) : null}

      <div className="form-footer">
        <button type="submit" className="btn btn-primary">
          Continue
        </button>
      </div>
    </form>
  );
}
